import axios from 'axios';
import { toast } from 'sonner';
import { Eye, EyeSlash } from '@phosphor-icons/react';
import useReglagesClient from '../../hooks/useReglagesClient';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * RP74 (D31 = B) — l'architecte décide, chantier par chantier, si le client voit les
 * montants (onglet « Paiements » et carte « Paiements » de « Mon chantier »).
 * Activé par défaut, sauf pour un promoteur ou une collectivité.
 * Affiché dans l'onglet Finances ; modifiable par l'architecte et le chef de projet.
 */
export default function ReglageMontantsClient({ chantierId }) {
  const { reglage, setReglage } = useReglagesClient(chantierId, true);
  if (!reglage) return null;

  const enregistrer = async (valeur) => {
    try {
      const { data } = await axios.put(
        `${API_URL}/api/chantiers/${chantierId}/reglages-client`,
        { client_voit_montants: valeur },
        { withCredentials: true },
      );
      setReglage(data);
      toast.success(data.client_voit_montants ? 'Le client voit désormais les montants' : 'Les montants sont masqués au client');
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Le réglage n'a pas pu être enregistré");
    }
  };

  const actif = reglage.client_voit_montants;
  return (
    <div className="mb-4 p-3 border border-[#E0E0DB] bg-[#FAFAF8] flex flex-col sm:flex-row sm:items-center gap-3" data-testid="reglage-montants-client">
      <div className="flex items-start gap-2 flex-1">
        {actif ? <Eye size={18} className="text-[#2D6A4F] mt-0.5" /> : <EyeSlash size={18} className="text-[#8B3A3A] mt-0.5" />}
        <div>
          <p className="text-sm font-semibold text-[#2C2C2C]">
            Le client voit les montants : {actif ? 'oui' : 'non'}
          </p>
          <p className="text-xs text-[#6B6B6B]">
            Paiements certifiés, déjà payé, reste à payer et garantie retenue, dans son espace « Mon chantier ».
            {!reglage.personnalise && ' Réglage par défaut'}
            {!reglage.personnalise && (reglage.par_defaut ? ' (activé pour un particulier).' : ' (désactivé pour un promoteur ou une collectivité).')}
          </p>
        </div>
      </div>
      {reglage.modifiable && (
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => enregistrer(!actif)}
            className="text-sm px-3 py-1.5 border border-[#2C2C2C] hover:bg-[#2C2C2C] hover:text-white"
            data-testid="reglage-montants-basculer"
          >
            {actif ? 'Masquer au client' : 'Montrer au client'}
          </button>
          {reglage.personnalise && (
            <button type="button" onClick={() => enregistrer(null)} className="text-xs text-[#6B6B6B] underline">
              Revenir au défaut
            </button>
          )}
        </div>
      )}
    </div>
  );
}
